function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var SvgNavMarkerActive = function SvgNavMarkerActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18.49,
    viewBox: "0 0 4.2333332 4.8921459",
    id: "svg8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "layer3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#1c2225",
      stroke: "none",
      fillOpacity: 1
    },
    id: "g4515-0",
    transform: "matrix(0.15176788,-0.08544714,0.08776536,0.14823886,1.1573685,1.9434745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4504-5",
    style: {
      fill: "#1c2225",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillOpacity: 1
    },
    d: "M 6.12132,6.12132 C 6.68393,5.55871 7,4.79565 7,4 7,3.20435 6.68393,2.44129 6.12132,1.87868 5.55871,1.31607 4.79565,1 4,1 3.20435,1 2.44129,1.31607 1.87868,1.87868 1.31607,2.44129 1,3.20435 1,4 1,4.79565 1.31607,5.55871 1.87868,6.12132 2.44129,6.68393 3.20435,7 4,7 4.79565,7 5.55871,6.68393 6.12132,6.12132 Z m 1.1852999,9.608986 -8.16971722,2.285364 c -0.38294758,0.102997 -1.46953058,-0.02763 -1.86242558,-0.079 -0.3929575,-0.05122 -0.7717648,-0.179493 -1.1148611,-0.377258 -0.3430832,-0.197759 -0.6437516,-0.46115 -0.884676,-0.775306 -0.240987,-0.314017 -0.709477,-0.840714 -0.8115556,-1.223288 L -7.674946,7.4134258 c -0.6165314,-2.3047523 -0.444289,-5.1673144 0.3250614,-7.42767353 0.7693998,-2.26043527 2.1920009,-4.24306107 4.0879544,-5.69719747 1.8959329,-1.4541308 4.18005813,-2.3144725 6.5635175,-2.4722141 2.3834724,-0.157734 4.7592336,0.3942014 6.8268677,1.586017 2.067594,1.191793 3.73424,2.9699628 4.789166,5.109642 1.054926,2.13967926 1.450729,4.5447721 1.137325,6.9110969 -0.313411,2.3663378 -1.321831,4.5877044 -2.89797,6.3831224 -1.575963,1.795415 -3.548929,3.280295 -5.8503561,3.924087 z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavMarkerActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-marker-active.7d882e25.svg";
export { ForwardRef as ReactComponent };